import PropTypes from 'prop-types';

export const AuditClientPropType = PropTypes.shape({
  getEntityAuditHistory: PropTypes.func.isRequired,
  getEntityAuditRecordDetail: PropTypes.func.isRequired,
});

/** `summary.kind` -> Component({ change, row, detail }) rendering that summarised change. */
export const AuditRenderersPropType = PropTypes.objectOf(PropTypes.elementType);

export const AuditFieldListPropType = PropTypes.arrayOf(PropTypes.string);

/** A field list, or `(summary, detail) => string[]` for fields hidden on some rows only. */
const AuditHiddenFieldsPropType = PropTypes.oneOfType([AuditFieldListPropType, PropTypes.func]);

/** Panels that take summarised changes out of the field diff, by `summary.kind`, in display order. */
export const AuditChangePanelsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    kinds: PropTypes.arrayOf(PropTypes.string).isRequired,
    subtitle: PropTypes.elementType,
  }),
);

const ShadowedTogglePropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
});

export const AuditRowDecorationPropType = PropTypes.shape({
  chips: PropTypes.arrayOf(PropTypes.node),
  muted: PropTypes.bool,
  note: PropTypes.node,
  mutedFields: AuditFieldListPropType,
});

/** The optional extension props, shared by EntityAuditHistory and EntityAuditHistoryDrawer. */
export const AuditExtensionPropTypes = {
  renderers: AuditRenderersPropType,
  hiddenFields: AuditHiddenFieldsPropType,
  snapshotExcludedFields: AuditFieldListPropType,
  getRowDecoration: PropTypes.func,
  shadowedToggle: ShadowedTogglePropType,
  renderRowActions: PropTypes.func,
  renderDetailExtras: PropTypes.func,
  changePanels: AuditChangePanelsPropType,
  isSnapshotHidden: PropTypes.bool,
  automaticFields: AuditFieldListPropType,
};
